import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../shared/services/api.service';

export interface BalanceData {
  name: string;
  availableBalance: {
    amount: number;
    currency: string;
  };
}

export interface BalanceResponse {
  error: boolean;
  data: {
    data: {
      balances: BalanceData;
    };
    meta: {
      message: string;
    };
  };
  message: string;
}

@Component({
  standalone: false,
  selector: 'app-balance',
  templateUrl: './balance.component.html',
  styleUrls: ['./balance.component.scss']
})
export class BalanceComponent implements OnInit {
  balance: BalanceData | null = null;
  loading = false;
  error: string | null = null;

  constructor(private apiService: ApiService) {}

  ngOnInit(): void {
    this.loadBalance();
  }

  loadBalance(): void {
    this.loading = true;
    this.error = null;
    
    this.apiService.getData('/api/airalo/balance').subscribe({
      next: (response: BalanceResponse) => {
        if (response && !response.error && response.data && response.data.data && response.data.data.balances) {
          this.balance = response.data.data.balances;
        } else {
          this.error = response.message || 'Failed to load balance data';
        }
        this.loading = false;
      },
      error: (err) => {
        console.error('Error fetching balance:', err);
        this.error = 'Error loading balance';
        this.loading = false;
      }
    });
  }

  refreshBalance(): void {
    this.loadBalance();
  }
}